import React from 'react';
import { crystalCombinations } from '../data/mock';

const CrystalCombinationsSection = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#F8F7F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Image - Shows first on mobile, left on desktop */}
          <div className="order-1">
            <div className="relative">
              <img
                src={crystalCombinations.image}
                alt="Natural crystal formations"
                className="w-full h-[350px] lg:h-[500px] object-cover"
              />
              <div className="absolute -top-4 -left-4 w-24 h-24 border border-[#B8A88A]/30" />
            </div>
          </div>

          {/* Content - Shows second on mobile, right on desktop */}
          <div className="order-2">
            <h2 className="text-3xl lg:text-4xl font-light text-[#333333] mb-6">
              {crystalCombinations.title}
            </h2>
            <p className="text-base text-[#666666] leading-relaxed mb-12">
              {crystalCombinations.description}
            </p>

            {/* Features */}
            <div className="space-y-8">
              {crystalCombinations.features.map((feature, index) => (
                <div key={index} className="bg-[#FFFEF8] p-6 lg:p-8">
                  <h3 className="text-lg font-light text-[#333333] mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-[#666666] leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CrystalCombinationsSection;
